import { LocalStorageKeys } from "@/constants/local-storage-keys";
import { useGetUser } from "@/hooks/requests/user/use-get-user";
import { useSyncExternalStore } from "react";

const CACHE_BUST_EVENT = "avatar-cache-bust";

const getCacheBustSnapshot = () => {
  if (typeof window === "undefined") return "1";
  return (
    window.localStorage.getItem(LocalStorageKeys.AVATAR_CACHE_BUST_KEY) ?? "1"
  );
};

const subscribeCacheBust = (callback: () => void) => {
  if (typeof window === "undefined") return () => {};
  const handler = () => callback();
  window.addEventListener(CACHE_BUST_EVENT, handler);
  window.addEventListener("storage", handler);
  return () => {
    window.removeEventListener(CACHE_BUST_EVENT, handler);
    window.removeEventListener("storage", handler);
  };
};

export const useAvatar = () => {
  const { user, isLoading, isError, error } = useGetUser();
  const cacheBust = useSyncExternalStore(
    subscribeCacheBust,
    getCacheBustSnapshot,
    () => "1",
  );
  const avatarUrl = user?.personalInfo?.avatarUrl ?? "";
  const avatarImageUrl = avatarUrl ? `${avatarUrl}?v=${cacheBust}` : "";

  return {
    user,
    avatarUrl,
    avatarImageUrl,
    isLoading,
    isError,
    error,
  };
};
